import { getConfig } from '@/lib/config'
import { getCookieValue } from '@/lib/cookie'
import { UserPreference } from '@/shared/api-generated-types'
import UserPreferencesModal from '@/widgets/UserPreferencesModal'
import { setCookie } from 'cookies-next'
import { useEffect, useState } from 'react'
import { gql, useQuery } from 'urql'

const { publicRuntimeConfig } = getConfig()

export const QUERY_MY_PREFERENCES = gql`
  query myPreferences {
    myPreferences {
      id
      name
      description
      icon
    }
  }
`
export const usersPreferencesPopup = 'user-preferences-popup'

const UserPreferencesWrapper = (): JSX.Element => {
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false)
  const [{ data, fetching }] = useQuery<{ myPreferences: UserPreference[] }>({
    query: QUERY_MY_PREFERENCES,
    pause: getCookieValue(usersPreferencesPopup) === 'true',
  })

  useEffect(() => {
    if (!data || fetching) return
    if (data.myPreferences.length === 0) {
      setIsPreferencesOpen(true)
      setCookie(usersPreferencesPopup, 'true', {
        path: '/',
        domain: publicRuntimeConfig.auth.authCookieDomain,
        maxAge: 60 * 60 * 24 * 365,
      })
    }
  }, [data, fetching])

  const handlePreferencesUpdate = (): void => {
    setIsPreferencesOpen(false)
  }

  if (!isPreferencesOpen) return <></>
  return (
    <UserPreferencesModal
      isOpen={isPreferencesOpen}
      onUpdate={handlePreferencesUpdate}
      onClose={handlePreferencesUpdate}
    />
  )
}

export default UserPreferencesWrapper
